import { type ReactNode, createContext } from 'react';

import type { SingleValueAlignment } from '../types/single-value-base-props.js';

export interface SingleValueContextProps {
  /** Optional icon to show left of the value. */
  prefixIcon?: ReactNode;
  /** Chart value as formatted string. Set to 'N/A' if invalid. */
  value: string;
  /** Unit to show in the right of the value. Set to '', if not provided.  */
  unit: string;
  /** Label text to show beneath the value. Set to '', if not provided. */
  label: string;
  /** Alignment of SingleValue icon, value and unit. */
  alignment?: SingleValueAlignment;
}

export const SingleValueContext = createContext<SingleValueContextProps>({
  value: '',
  unit: '',
  label: '',
});
